import React, { useState, useCallback, useEffect } from "react";
import axios from "../../utils/axiosConfig";
import "../styles/AdminTable.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";

const AdminAdmissions = () => {

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [date, setDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  /* ================= DATE FORMAT ================= */
const formatDate=(date)=>{
  return new Date(date).toLocaleDateString("en-IN",{
  day:"2-digit",
  month:"2-digit",
  year:"numeric"
  }).replace(/\//g,"-");
  };

  const recordsPerPage = 10;

  const loadData = useCallback(async () => {
    try {
      const res = await axios.get("/api/admissions");
      console.log(res.data); // 👈 CHECK HERE
      setData(res.data);
    } catch (err) {
      console.error("ERROR:", err);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const deleteItem = async (id) => {

    if (!window.confirm("Delete this enquiry?")) return;

    axios.delete(`/api/admissions/${id}`);
    loadData();
  };

  /* SEARCH + DATE FILTER */

  const filteredData = data.filter((item) => {

    const matchSearch =
      item.fullName.toLowerCase().includes(search.toLowerCase()) ||
      item.phone.toLowerCase().includes(search.toLowerCase()) ||
      item.email.toLowerCase().includes(search.toLowerCase());

    const matchDate = date
      // ? new Date(item.birthdate).toISOString().slice(0, 10) === date
      ? new Date(item.created_at).toLocaleDateString("en-CA").slice(0, 10) === date
      : true;

    return matchSearch && matchDate;

  });

  /* PAGINATION */

  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  // const today = new Date().toDateString();
  const today = new Date().toLocaleDateString("en-CA");

  const totalMessages = data.length;

  const todayMessages = data.filter(
    // (item) => new Date(item.submitDate).toDateString() === today
    (item) => new Date(item.submitDate).toLocaleDateString("en-CA") === today
  ).length;

  /* EXCEL EXPORT */

  const exportExcel = () => {

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Admissions");

    const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const file = new Blob([buffer], { type: "application/octet-stream" });

    saveAs(file, "Admission_Enquiries.xlsx");

  };

  /* GRAPH */

  const chartData = data.reduce((acc, item) => {

    const d = new Date(item.created_at).toLocaleDateString("en-IN");

    const found = acc.find((x) => x.date === d);

    if (found) {
      found.count += 1;
    } else {
      acc.push({ date: d, count: 1 });
    }

    return acc;

  }, []);

  return (

    <div>

      <h2 className="admin-title">
        Admission Enquiries
      </h2>

      {/* DASHBOARD */}
      <div className="dashboard">
        <div className="card">Total Enquiries : {totalMessages}</div>
        <div className="card">Today Enquiries : {todayMessages}</div>
      </div>

      {/* FILTERS */}

      <div className="d-flex gap-3 flex-wrap mb-3">

        <input
          type="text"
          placeholder="Search..."
          className="search-box"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <input
          type="date"
          className="search-box"
          onChange={(e) => setDate(e.target.value)}
        />

        <button className="export-btn" onClick={exportExcel}>
          Export Excel
        </button>

      </div>

      {/* GRAPH */}

      <div style={{ overflowX: "auto", marginBottom: "20px" }}>

        <BarChart width={600} height={300} data={chartData}>
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="count" />
        </BarChart>

      </div>

      {/* TABLE */}

      <table className="admin-table">

        <thead>

          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Birth Date</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Class</th>
            <th>Remark</th>
            <th>Date</th>
            <th>Action</th>
          </tr>

        </thead>

        <tbody>

          {currentRecords.map((item) => (

            <tr key={item.id}>

              <td>{item.id}</td>
              <td>{item.fullName}</td>
              {/* <td>{item.birthdate}</td> */}
              <td>{formatDate(item.birthdate)}</td>
              <td>{item.phone}</td>
              <td>{item.email}</td>
              <td>{item.class_name}</td>
              <td>{item.remark}</td>
              {/* <td>{item.created_at}</td> */}
              <td>{formatDate(item.created_at)}</td>
              

              <td>

                <button
                  className="delete-btn"
                  onClick={() => deleteItem(item.id)}
                >
                  Delete
                </button>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

      {/* PAGINATION */}

      <div className="pagination">

        {Array.from({ length: totalPages }, (_, i) => (

          <button
            key={i}
            onClick={() => setCurrentPage(i + 1)}
            className={currentPage === i + 1 ? "active" : ""}
          >
            {i + 1}
          </button>

        ))}

      </div>

    </div>

  );

};

export default AdminAdmissions;